import "core-js/modules/web.atob.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.fill.js";
//
//
//
//
//
//
import OrderInput from "./../../components/order/input/Input";
import { mapGetters } from "vuex";
export default {
  name: "Orders.vue",
  data: function data() {
    return {
      shoppingCard: [],
      order: null
    };
  },
  components: {
    OrderInput: OrderInput
  },
  computed: mapGetters({
    currentProvider: "profile/currentProvider"
  }),
  created: function created() {
    var userOrder = JSON.parse(unescape(atob(this.$route.params.info)));
    var orderItems = userOrder.items.flatMap(function (order) {
      return Array(order.quantity).fill(order);
    });
    this.shoppingCard = orderItems;
    this.order = userOrder;
  }
};